import {apiMethod, APIService} from 'services/APIService';

export interface MlsCounters {
  rieltors: number;
  objects: number;
  deals: number;
}

export class MlsAPI extends APIService {
  counters = apiMethod<MlsCounters>(
    () => this.fetcher.request({
      method: 'GET',
      url: `/api/mls/counters/`,
    }),
  );
}
